import React from "react";
import useField, { useFieldProps } from "src/hooks/form/useField";
import RfqBidContainerTabs from './RfqBidsComponents/RfqBidContainerTabs';
import SEQuotePanel from './SEQuotesComponents/SEQuotePanel';

const useRfqBids = <T>(props: useFieldProps<T>) => {
  const formOptions = {
    rules: [
      {
        validator: (rule, value, callback) => {
          const noError = Object.keys(value?.bids || {}).every(key => value.bids[key].length);
          if (value?.bids && noError) {
            return callback();  
          }
          return callback('Please select a bid.');
        }
      }
    ],
  };

  const field = useField({
    ...props,
    formOptions,
  });
  
  const decorator = (child: React.ReactElement): React.ReactNode => {
    // Editable view: the bid-selection UI (bids-search + rich bid cards). Read-only/approval view
    // (SMT72): the saved value is the flattened QuoteType (see bidToQuote on submit) and the bid cards'
    // rich source fields are gone, so render it through the quote panel instead — it shows this vendor's
    // slice of the saved Quote Candidates (SMF427) with the selection highlighted, and reports it to the
    // combined footer totals, exactly like the quote tabs.
    // Pass THIS node's own field model (not whatever was threaded through child.props by the parent
    // render): on SMT71 the sibling fields are never rendered inline, so the field-group's "all refs
    // populated" re-render never fires — without this the panel would keep an undefined field.
    const Panel = field?.disabled ? SEQuotePanel : RfqBidContainerTabs;
    return field.decorator(
      React.createElement(
        Panel,
        { ...child.props, field },
      )
    );
  };

  return {
    ...field,
    decorator,
  };

};

export default useRfqBids;
